import React from "react";

class BasicButtonColor {
    static Gray = "gray_button";
    static Blue = "blue_button";
}

function BasicButton({children, onClick, disabled = null, className = "", buttonColor = BasicButtonColor.Gray, type}) {
    const buttonStyles = {
        [BasicButtonColor.Gray]: "bg-gray-600 hover:bg-gray-700 disabled:bg-gray-500",
        [BasicButtonColor.Blue]: "bg-blue-600 hover:bg-blue-700 disabled:bg-blue-900",
    }
    return (
        <button
            className={`${className} ${buttonStyles[buttonColor]} disabled:pointer-events-none text-white font-medium py-1 px-4 rounded`}
            onClick={onClick}
            disabled={disabled}
            type={type}
        >
            {children}
        </button>
    );
}

export {BasicButton, BasicButtonColor};